import { get } from '../../base-portal-api';

import { CurrentProfileResponse } from './types-get-current';

export function getCurrentProfile(authToken?: string) {
  return get('v1/user/profile', {
    headers: { authorization: `Bearer ${authToken}` },
  }).json<CurrentProfileResponse>();
}
